import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';

export const ConfigurationSection = (props) => {

    const onChange = (value, name) => {
        props.onFormChange(name, value.toString());
    }
    return (
        <div className="configuration-section section">
            <form className={props.isFormValid ? "" : "was-validated"} noValidate>
                <div className="row content">
                    <div className="col-12 col-sm-4 header">
                        <h4>Configuration</h4>
                        <p>These selections will be used to customize your experience.</p>
                    </div>
                    <div className="col-12 col-sm-8 fields">
                        <div className="row">
                            <div className="col-12 col-sm-6 select-wrapper">
                                <MultiSelectBox name="countryId" label="Country" idField="id" valueField="name"
                                    options={props.countries}
                                    selectedValues={props.user.countryId}
                                    onChange={onChange}
                                    isRequired={true}
                                    errorMessage="Country is required"
                                    isMulti={false}
                                />
                            </div>
                            <div className="col-12 col-sm-6 select-wrapper">
                                <MultiSelectBox name="defaultLocationId" label="Default Location" idField="id" valueField="name"
                                    options={props.locations}
                                    selectedValues={props.user.defaultLocationId}
                                    onChange={onChange}
                                    isRequired={true}
                                    errorMessage="Default Location is required"
                                    isMulti={false}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-6 select-wrapper">
                                <MultiSelectBox name="departmentIds" label="Follow tasks from these Departments" idField="id" valueField="name"
                                    options={props.departments}
                                    selectedValues={props.user.departmentIds}
                                    onChange={onChange}
                                    isMulti={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className="footer">
                <button name="configurationSaveButton" className="btn btn-primary save-changes" onClick={props.onSaveChanges}>Save Changes</button>
            </div>
        </div>
    );
}

ConfigurationSection.propTypes = {
    user: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    countries: PropTypes.array.isRequired,
    locations: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired
};

export default ConfigurationSection;

